const accountTypeDescriptions = {
    CHECKING: 'Checking',
    SAVINGS: 'Savings',
    TRANSACTION_INDIVIDUAL: 'Cash Account',
    TRANSACTION_JOINT: 'Joint Cash Account',
    DEPOSIT: 'Deposit Account'
};
export const getAccountTypeDisplayName = (accountType) => accountTypeDescriptions[accountType];
